module.exports = __webpack_public_path__ + "ab7ec3c4d5cbf49a950f34d95b2d9944.svg";